import SearchIcon from './icons/SearchIcon';

interface SearchBarProps {
    className?: string;
    value: string;
    placeholder?: string;
    onChange: (newValue: string) => void;
}

const SearchBar = (props: SearchBarProps) => {
    return (
        <div className={'relative ' + props.className}>
            <input
                className={
                    'py-2 pl-10 pr-4 rounded-[5px] text-sm text-foreground bg-text-contrast border border-transparent shadow-sm ' +
                    'placeholder:tracking-wide w-full sm:min-w-80 focus:border-primary focus:outline-none transition-all'
                }
                type={'text'}
                placeholder={props.placeholder}
                value={props.value}
                onChange={(event) => props.onChange(event.target.value)}
            />
            <SearchIcon className={'text-foreground absolute top-2 left-2'} />
        </div>
    );
};

export default SearchBar;
